import {
  Container,
  Nav,
  Navbar,
} from "react-bootstrap";
import "./MiddleNavigation.scss";
import logo from "../../../assets/images/essilor-logo.webp";
//import logo2 from "../../../assets/images/MedicalAffairs-RGB.svg";
import logo2 from "../../../assets/images/Transparent Logo White.png";
import { Link, useHistory } from "react-router-dom";
import { useState } from "react";
import UserMenu from "../header/UserMenu";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/user/userSlice";

function MiddleNavigation(props) {
  const user = useSelector(selectUser);
  const history = useHistory();
  const [expandedNavItem, setExpandedNavItem] = useState({
    technologies: false,
    resources: false,
  });


  const closeMenu = () => {
    if (window.innerWidth < 800) {
      const navToggler = document.getElementsByClassName("navbar-toggler");
      navToggler[0].click();
    }
  };

  const toggleMobileExpanded = (isExpanded, navItem) => {
    setExpandedNavItem({ ...expandedNavItem, [navItem]: isExpanded });
  };

  return (
    <>
      <UnauthenticatedTemplate>
        <div className="midnav">
          <Navbar bg="light" expand="lg">
            <Container>
              <Navbar.Brand href="#home">
                <img src={logo} id="logo" alt="logo" />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />

              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto" activeKey={history.location.pathname}>
                  {/*<Nav.Link onClick={closeMenu} as={Link} to='/register'>Register</Nav.Link>*/}
                  <Nav.Link onClick={closeMenu} as={Link} to="/">
                    Home Page
                  </Nav.Link>
                  <Nav.Link onClick={closeMenu} as={Link} to="/issue-request">
                    Issue/Request
                  </Nav.Link>
                  <Nav.Link onClick={closeMenu} as={Link} to="/faqs">
                    FAQs and Resources
                  </Nav.Link>
                </Nav>
                <div className="topnav-collapse">
                  <Nav className="me-auto justify-content-end">
                    {/*<Nav.Link onClick={closeMenu} as={Link} to='/contact'>Contact</Nav.Link>*/}
                  </Nav>
                  <UserMenu />
                </div>
              </Navbar.Collapse>
              <Navbar.Brand href="#home2">
                <img src={logo2} id="logo2" alt="logo2" />
              </Navbar.Brand>
            </Container>
          </Navbar>
        </div>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <div className="midnav">
          <Navbar bg="light" expand="lg">
            <Container>
              <Navbar.Brand href="#home">
                <img src={logo} id="logo" alt="logo" />
              </Navbar.Brand>
              {/*<Navbar.Brand href="#home2">*/}
              {/*    <img*/}
              {/*        src={logo2}*/}
              {/*        id="logo2"*/}
              {/*        alt="logo2"*/}
              {/*    />*/}
              {/*</Navbar.Brand>*/}
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <UserMenu />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto" activeKey={history.location.pathname}>
                  <Nav.Link onClick={closeMenu} as={Link} to="/dashboard">
                    Home Page
                  </Nav.Link>
                  {/*{ user?.userRole === 'ESSILORADMIN' && <Nav.Link onClick={closeMenu} as={Link} to='/essilor-admin'>Essilor Admin</Nav.Link>}*/}
                  <Nav.Link onClick={closeMenu} as={Link} to="/issue-request">
                    Issue/Request
                  </Nav.Link>
                  <Nav.Link onClick={closeMenu} as={Link} to="/requests">
                    View Issues
                  </Nav.Link>
                  <Nav.Link onClick={closeMenu} as={Link} to="/faqs">
                    FAQs and Resources
                  </Nav.Link>
                  {user && (user.userRole === "MEDIATOR" || user.userRole === "ESSILORADMIN") && (
                     <Nav.Link onClick={closeMenu} as={Link} to="/reports">
                    Reports
                  </Nav.Link>
                  )}

                  {/*<Dropdown onToggle={(nextShow) => toggleMobileExpanded(nextShow, 'technologies')} as={NavItem}>*/}
                  {/*    <Dropdown.Toggle as={NavLink}>*/}
                  {/*        TECHNOLOGY*/}
                  {/*        <Icon className="plus-icon mobile-only" name={expandedNavItem.technologies ? 'close' : 'plus'}/>*/}
                  {/*    </Dropdown.Toggle>*/}
                  {/*    <Dropdown.Menu*/}
                  {/*      className="multi-menu-dropdown">*/}
                  {/*        <div className="resource-menu">*/}
                  {/*            <div className="container">*/}
                  {/*                <div className="submenu">*/}
                  {/*                    <div className="submenu__wrapper">*/}
                  {/*                        <div className="submenu__label">*/}
                  {/*                            <b>TOOLS</b>*/}
                  {/*                        </div>*/}
                  {/*                        <div className="submenu__item">*/}
                  {/*                            <a href="https://www.essilorpro.com/technology/visioffice" rel="noreferrer" target="_blank">VISIO OFFICE</a>*/}
                  {/*                        </div>*/}
                  {/*                        <div className="submenu__item">*/}
                  {/*                            <a href="https://www.essilorpro.com/technology/meyefit" rel="noreferrer" target="_blank">MEYEFIT</a>*/}
                  {/*                        </div>*/}
                  {/*                    </div>*/}
                  {/*                    <div className="submenu__wrapper">*/}
                  {/*                        <div className="submenu__label">*/}
                  {/*                            <b>LENS TECHNOLOGY</b>*/}
                  {/*                        </div>*/}
                  {/*                        <div className="submenu__item">*/}
                  {/*                            <a href="https://www.essilorpro.com/technology/transitions-gen-8" rel="noreferrer" target="_blank">TRANSITIONS GEN8</a>*/}
                  {/*                        </div>*/}
                  {/*                        <div className="submenu__item">*/}
                  {/*                            <a href="https://www.essilorpro.com/technology/essential-blue-series" rel="noreferrer" target="_blank">ESSENTIAL BLUE SERIES</a>*/}
                  {/*                        </div>*/}
                  {/*                        <div className="submenu__item">*/}
                  {/*                            <a href="https://www.essilorpro.com/technology/ultimate-lens-package" rel="noreferrer" target="_blank">ULTIMATE LENS PACKAGE</a>*/}
                  {/*                        </div>*/}
                  {/*                        <div className="submenu__item">*/}
                  {/*                            <a href="https://www.essilorpro.com/technology/anti-fog-solutions" rel="noreferrer" target="_blank">ANTI-FOG SOLUTIONS</a>*/}
                  {/*                        </div>*/}
                  {/*                    </div>*/}
                  {/*                    <div className="submenu__wrapper">*/}
                  {/*                        <div className="submenu__label">*/}
                  {/*                            <b>OTHER RESOURCES</b>*/}
                  {/*                        </div>*/}
                  {/*                        <div className="submenu__item">*/}
                  {/*                            <a href="https://www.essilorpro.com/technology/latest-products" rel="noreferrer" target="_blank">OTHER PRODUCT TECHNOLOGY</a>*/}
                  {/*                        </div>*/}
                  {/*                        <div className="submenu__item">*/}
                  {/*                            <a href="https://www.essilorusa.com/patents" rel="noreferrer" target="_blank">PATENTS</a>*/}
                  {/*                        </div>*/}
                  {/*                    </div>*/}
                  {/*                </div>*/}
                  {/*            </div>*/}
                  {/*        </div>*/}

                  {/*    </Dropdown.Menu>*/}
                  {/*</Dropdown>*/}

                  {/*<Dropdown onToggle={(nextShow) => toggleMobileExpanded(nextShow, 'resources')} as={NavItem}>*/}
                  {/*    <Dropdown.Toggle as={NavLink}>*/}
                  {/*        Resources*/}
                  {/*        <Icon className="plus-icon mobile-only" name={expandedNavItem.resources ? 'close' : 'plus'}/>*/}
                  {/*    </Dropdown.Toggle>*/}
                  {/*    <Dropdown.Menu*/}
                  {/*      className="single-menu-dropdown">*/}
                  {/*        <div className="resource-menu">*/}
                  {/*            <div className="container">*/}
                  {/*                <div className="dropdown-item">*/}
                  {/*                    <a href="https://www.essilorpro.com/resources/crizal" rel="noreferrer" target="_blank">CRISAL</a>*/}
                  {/*                </div>*/}
                  {/*                <div className="dropdown-item">*/}
                  {/*                    <a href="https://www.essilorpro.com/resources/transitions" rel="noreferrer" target="_blank">TRANSITIONS</a>*/}
                  {/*                </div>*/}
                  {/*                <div className="dropdown-item">*/}
                  {/*                    <a href="https://www.essilorpro.com/resources/varilux" rel="noreferrer" target="_blank">VARILUX</a>*/}
                  {/*                </div>*/}
                  {/*                <div className="dropdown-item">*/}
                  {/*                    <a href="https://www.essilorpro.com/resources/xperiouv" rel="noreferrer" target="_blank">XPERIO</a>*/}
                  {/*                </div>*/}
                  {/*                <div className="dropdown-item">*/}
                  {/*                    <a href="https://www.essilorpro.com/resources/eyezen" rel="noreferrer" target="_blank">EYEZEN</a>*/}
                  {/*                </div>*/}
                  {/*                <div className="dropdown-item">*/}
                  {/*                    <a href="https://www.essilorpro.com/resources/essential-blue-series" rel="noreferrer" target="_blank">ESSENTIAL BLUE SERIES</a>*/}
                  {/*                </div>*/}
                  {/*                <div className="dropdown-item">*/}
                  {/*                    <a href="https://www.essilorpro.com/resources/ray-ban" rel="noreferrer" target="_blank">RAY-BAN AUTHENTIC</a>*/}
                  {/*                </div>*/}
                  {/*                <div className="dropdown-item">*/}
                  {/*                    <a href="https://www.essilorpro.com/resources/find-a-sales-consultant" rel="noreferrer" target="_blank">FIND A SALES CONSULTANT</a>*/}
                  {/*                </div>*/}
                  {/*            </div>*/}
                  {/*        </div>*/}

                  {/*    </Dropdown.Menu>*/}
                  {/*</Dropdown>*/}
                </Nav>
                <div className="topnav-collapse">
                  <Nav className="me-auto justify-content-end">
                    {/*<Nav.Link onClick={closeMenu} as={Link} to='/contact'>Contact</Nav.Link>*/}
                    {/*<Nav.Link onClick={closeMenu} as={Link} to='/help'>Help</Nav.Link>*/}
                    {/*<Nav.Link onClick={closeMenu} as={Link} to='/help/faqs'>FAQs</Nav.Link>*/}
                    {/*<a className="nav-link" rel="noreferrer"*/}
                    {/*   href='https://essilor.oktapreview.com/home/oidc_client/0oaf3ch4czTDuAjdl0h7/aln5z7uhkbM6y7bMy0g7'*/}
                    {/*   target="_blank">EssilorPRO</a>*/}
                  </Nav>
                </div>
              </Navbar.Collapse>
              <Navbar.Brand href="#home2">
                <img src={logo2} id="logo2" alt="logo2" />
              </Navbar.Brand>
            </Container>
          </Navbar>
        </div>
      </AuthenticatedTemplate>
    </>
  );
}

export default MiddleNavigation;
